(() => {
  if (window.__faProductCitySyncBootstrapped) return;
  window.__faProductCitySyncBootstrapped = true;

  const normalize = (value = '') => String(value).trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  let pendingMobileCityFocusRestore = null;
  let mobileCityFocusRestoreToken = 0;

  function armMobileCityFocusRestore(nativeSelect) {
    if (!nativeSelect?.id || !window.matchMedia?.('(max-width: 749px)').matches) return;

    const token = ++mobileCityFocusRestoreToken;
    pendingMobileCityFocusRestore = {
      token,
      targetId: nativeSelect.id,
      x: window.scrollX,
      y: window.scrollY,
      expiresAt: Date.now() + 5000
    };

    window.setTimeout(() => {
      if (pendingMobileCityFocusRestore?.token === token) pendingMobileCityFocusRestore = null;
    }, 5000);
  }

  document.addEventListener('focus', (event) => {
    const pending = pendingMobileCityFocusRestore;
    if (!pending) return;

    if (Date.now() > pending.expiresAt) {
      pendingMobileCityFocusRestore = null;
      return;
    }

    if (event.target?.id !== pending.targetId) return;

    pendingMobileCityFocusRestore = null;
    requestAnimationFrame(() => {
      window.scrollTo({ left: pending.x, top: pending.y, behavior: 'auto' });
    });
  }, true);

  function cityOption(select) {
    if (!select) return null;
    return Array.from(select.querySelectorAll('.product-form__input')).find((field) => {
      const legend = normalize(field.querySelector('legend')?.textContent || '');
      const label = normalize(field.querySelector('.form__label')?.textContent || '');
      return ['city', 'delivery city', 'available delivery city'].includes(legend || label);
    }) || null;
  }

  function nativeCitySelect(root) {
    if (!root) return null;
    return Array.from(root.querySelectorAll('select')).find((select) => {
      const label = normalize(select.closest('.product-form__input')?.querySelector('.form__label')?.textContent || '');
      return ['city', 'delivery city', 'available delivery city'].includes(label);
    }) || root.querySelector('select');
  }

  function currentNativeCitySelect(customSelect) {
    if (!customSelect) return null;

    const productInfo = customSelect.closest('product-info') || document.querySelector('product-info[data-product-id]');
    if (!productInfo) return null;

    const variantSelects = productInfo.querySelector('variant-selects, variant-radios');
    const cityField = cityOption(variantSelects);
    return nativeCitySelect(cityField);
  }

  function hasCitySelection(customSelect) {
    if (!customSelect?.value) return false;
    const selected = customSelect.options?.[customSelect.selectedIndex];
    const cityName = String(selected?.dataset.cityName || '').trim();
    return Boolean(cityName || String(customSelect.value).trim());
  }

  function setPriceState(customSelect) {
    if (!customSelect) return;
    const productInfo = customSelect.closest('product-info') || document.querySelector('product-info[data-product-id]');
    if (!productInfo) return;
    productInfo.dataset.faCitySelected = hasCitySelection(customSelect) ? 'true' : 'false';
  }

  function syncValue(customSelect) {
    if (!customSelect?.value) return;

    const nativeSelect = currentNativeCitySelect(customSelect);
    if (!nativeSelect) return;

    const selectedCustom = customSelect.options[customSelect.selectedIndex];
    const raw = selectedCustom?.dataset.cityName || selectedCustom?.textContent?.split(' - ')[0] || customSelect.value;
    const target = normalize(raw);
    const option = Array.from(nativeSelect.options).find((item) => normalize(item.textContent) === target || normalize(item.value) === target);

    if (!option || nativeSelect.value === option.value) return;
    armMobileCityFocusRestore(nativeSelect);
    nativeSelect.value = option.value;
    nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function sync(customSelect) {
    setPriceState(customSelect);
    syncValue(customSelect);
  }

  function bind(customSelect) {
    if (!customSelect) return false;

    if (customSelect.dataset.faCitySync !== 'true') {
      customSelect.dataset.faCitySync = 'true';

      new MutationObserver(() => sync(customSelect)).observe(customSelect, {
        childList: true,
        subtree: true
      });
    }

    sync(customSelect);
    return true;
  }

  function applyDefaultCheapestVariant(variantSelects) {
    if (!variantSelects || variantSelects.dataset.faDefaultCheapest !== 'true') return false;
    if (variantSelects.dataset.faDefaultApplied === 'true') return false;

    const url = new URL(window.location.href);
    if (url.searchParams.has('variant')) return false;

    let optionValues = [];
    try {
      optionValues = JSON.parse(variantSelects.dataset.faDefaultOptionValues || '[]');
    } catch (error) {
      console.warn('Unable to read the default product variant options.', error);
      return false;
    }

    if (!Array.isArray(optionValues) || optionValues.length === 0) return false;

    const groups = Array.from(
      variantSelects.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown')
    ).filter((group) => !group.hasAttribute('data-fa-native-city-wrapper'));

    let changed = false;
    let eventTarget = null;

    optionValues.forEach((optionValue, index) => {
      const group = groups[index];
      if (!group) return;

      const targetValue = String(optionValue);
      const radios = Array.from(group.querySelectorAll('input[type="radio"]'));

      if (radios.length) {
        const input = radios.find((radio) => radio.value === targetValue);
        if (!input) return;

        if (!input.checked) {
          radios.forEach((radio) => {
            radio.checked = false;
          });
          input.checked = true;
          changed = true;
        }
        eventTarget = input;
        return;
      }

      const select = group.querySelector('select');
      if (!select) return;
      const option = Array.from(select.options).find((item) => item.value === targetValue);
      if (!option) return;

      Array.from(select.options).forEach((item) => item.removeAttribute('selected'));
      option.setAttribute('selected', 'selected');
      if (select.value !== targetValue) {
        select.value = targetValue;
        changed = true;
      }
      eventTarget = select;
    });

    if (!changed || !eventTarget) return false;

    variantSelects.dataset.faDefaultApplied = 'true';

    const productInfo = variantSelects.closest('product-info');
    const defaultVariantId = variantSelects.dataset.faDefaultVariantId;
    if (productInfo && defaultVariantId) {
      productInfo.querySelectorAll('form[id^="product-form-"] input[name="id"]').forEach((input) => {
        input.value = defaultVariantId;
      });
    }

    requestAnimationFrame(() => {
      eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
    });

    return true;
  }

  function initDefaultVariants(root = document) {
    const variantPickers = [];

    if (root.matches?.('variant-selects[data-fa-default-cheapest="true"]')) variantPickers.push(root);
    root.querySelectorAll?.('variant-selects[data-fa-default-cheapest="true"]').forEach((picker) => variantPickers.push(picker));

    variantPickers.forEach(applyDefaultCheapestVariant);
    return variantPickers.length > 0;
  }

  function init(root = document) {
    initDefaultVariants(root);

    const selects = [];

    if (root.matches?.('[data-fa-city]')) selects.push(root);
    root.querySelectorAll?.('[data-fa-city]').forEach((select) => selects.push(select));

    selects.forEach(bind);
    return selects.length > 0;
  }

  document.addEventListener('change', (event) => {
    const customSelect = event.target.closest?.('[data-fa-city]');
    if (!customSelect) return;
    bind(customSelect);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
